import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { TagModel } from "../models/tag/tagDTO";
import { TagSaveModel } from "../models/tag/tagSaveDTO";
import { Guid } from "guid-typescript";
import { IGridOption } from "../models/shared/gridOption";
let TagsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g;
    let TagsModule = class TagsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "tag";
            this.tags = [];
            this.totalCount = 0;
        }
        async GetTags(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetTags(plainToClass(TagModel, data.tags));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async AddTag(tag) {
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, tag);
            if (data) {
                return data;
            }
        }
        async EditTag(tag) {
            var url = `${getTenantId()}/${this.apiNode}/update`;
            let { data } = await service.put(url, tag);
            if (data) {
                return data;
            }
        }
        async DeleteTagById(tagId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/` + tagId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        SetTags(tags) {
            this.tags = tags;
        }
        SetTotalCount(count) {
            this.totalCount = count;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IGridOption !== "undefined" && IGridOption) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], TagsModule.prototype, "GetTags", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof TagSaveModel !== "undefined" && TagSaveModel) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], TagsModule.prototype, "AddTag", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof TagSaveModel !== "undefined" && TagSaveModel) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], TagsModule.prototype, "EditTag", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof Guid !== "undefined" && Guid) === "function" ? _g : Object]),
        __metadata("design:returntype", Promise)
    ], TagsModule.prototype, "DeleteTagById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "SetTags", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], TagsModule.prototype, "SetTotalCount", null);
    TagsModule = __decorate([
        Module({ dynamic: true, store: store, name: "tag", namespaced: true })
    ], TagsModule);
    return TagsModule;
})();
export const TagModule = getModule(TagsModule);
